var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "question answer participant-view" },
    [
      _c(
        "b-row",
        { staticClass: "answer-row" },
        [
          _c(
            "b-col",
            { staticClass: "col-text" },
            [
              _vm.questionsSelectActive
                ? _c("b-checkbox", {
                    staticClass: "question-select-cb",
                    attrs: { size: "is-small" },
                    model: {
                      value: _vm.questionSelected,
                      callback: function($$v) {
                        _vm.questionSelected = $$v
                      },
                      expression: "questionSelected"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "question-text",
                  class: { "is-requirement": _vm.question.requirement },
                  attrs: { disabled: _vm.question.requirement },
                  on: {
                    click: function($event) {
                      _vm.questionOpen = !_vm.questionOpen
                    }
                  }
                },
                [
                  _vm.question.required && !_vm.question.requirement
                    ? _c(
                        "span",
                        { staticClass: "required-badge" },
                        [
                          _c("b-badge", { attrs: { variant: "danger" } }, [
                            _vm._v("R")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.requirement
                    ? _c(
                        "span",
                        { staticClass: "requirement-badge" },
                        [
                          _c("b-badge", { attrs: { variant: "danger" } }, [
                            _vm._v("Rqmt")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.questionnaireNames.length
                    ? _c(
                        "span",
                        {
                          staticClass: "questionnaire-badge",
                          attrs: {
                            id: "questionnaire-badge-" + _vm.question._id
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("b-badge", { attrs: { variant: "strata" } }, [
                            _vm._v("Q")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target:
                                  "questionnaire-badge-" + _vm.question._id,
                                triggers: "hover"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "questionnaire-badge-tooltip" },
                                [
                                  _c("strong", [_vm._v("In Questionnaires:")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.questionnaireNames, function(
                                    name,
                                    i
                                  ) {
                                    return _c("div", { key: i }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(name) +
                                          "\n              "
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.answerIsRecalled
                    ? _c(
                        "span",
                        { staticClass: "recalled-badge" },
                        [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: "warning",
                                title:
                                  "Answer was recalled from a previous project"
                              }
                            },
                            [_vm._v("Recalled")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.questionNumber) + ". ")]),
                  _vm._v(" " + _vm._s(_vm.question.text) + "\n      ")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "col-last-updated", attrs: { cols: "2" } },
            [
              _c("div", [
                _c("div", [_vm._v(_vm._s(_vm.lastUpdatedDate.split(" ")[0]))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.lastUpdatedDate
                        .split(" ")
                        .slice(1)
                        .join(" ")
                    )
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "col-info-actions", attrs: { cols: "2" } },
            [
              _c(
                "div",
                { staticClass: "col-info" },
                [
                  _vm.questionIsAnswered
                    ? _c("b-icon", {
                        attrs: { icon: "check", type: "is-success" }
                      })
                    : _c("b-icon", {
                        attrs: { icon: "close", type: "is-danger" }
                      })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "detail-row" },
        [
          _c(
            "b-col",
            [
              !_vm.question.requirement
                ? _c(
                    "b-collapse",
                    {
                      staticClass: "detail-container",
                      attrs: { id: _vm.question._id },
                      model: {
                        value: _vm.questionOpen,
                        callback: function($$v) {
                          _vm.questionOpen = $$v
                        },
                        expression: "questionOpen"
                      }
                    },
                    [
                      _c("QuestionAnswerForm", {
                        attrs: {
                          "project-in-review": _vm.projectInReview,
                          question: _vm.question
                        }
                      }),
                      _vm._v(" "),
                      _vm.displayAnswerHistory
                        ? _c(
                            "b-row",
                            { staticClass: "answer-history-section" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticClass: "answer-history-toggle",
                                      attrs: { role: "tab" },
                                      on: {
                                        click: function($event) {
                                          _vm.historyOpen = !_vm.historyOpen
                                        }
                                      }
                                    },
                                    [
                                      _c("strong", [_vm._v("Answer History")]),
                                      _vm._v(" "),
                                      !_vm.historyOpen
                                        ? _c("b-icon", {
                                            attrs: { icon: "chevron-right" }
                                          })
                                        : _c("b-icon", {
                                            attrs: { icon: "chevron-down" }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: { role: "tablist" },
                                      model: {
                                        value: _vm.historyOpen,
                                        callback: function($$v) {
                                          _vm.historyOpen = $$v
                                        },
                                        expression: "historyOpen"
                                      }
                                    },
                                    [
                                      _c("QuestionAnswerHistory", {
                                        attrs: {
                                          "question-answer": _vm.questionAnswer
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }